import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const WorkspacesAutoNameAlertDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkspacesAutoNameAlert"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creationMethod"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idMemberCreator"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"me","block":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oneTimeMessagesDismissed"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"WorkspacesAutoNameAlert","document":WorkspacesAutoNameAlertDocument}} as const;
export type WorkspacesAutoNameAlertQueryVariables = Types.Exact<{
  orgId: Types.Scalars['ID'];
}>;


export type WorkspacesAutoNameAlertQuery = (
  { __typename: 'Query' }
  & { organization?: Types.Maybe<(
    { __typename: 'Organization' }
    & Pick<Types.Organization, 'creationMethod' | 'displayName' | 'id' | 'idMemberCreator' | 'url'>
  )>, member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id' | 'oneTimeMessagesDismissed'>
  )> }
);

/**
 * __useWorkspacesAutoNameAlertQuery__
 *
 * To run a query within a React component, call `useWorkspacesAutoNameAlertQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspacesAutoNameAlertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspacesAutoNameAlertQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useWorkspacesAutoNameAlertQuery(
  baseOptions: TrelloQueryHookOptions<
    WorkspacesAutoNameAlertQuery,
    WorkspacesAutoNameAlertQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: WorkspacesAutoNameAlertDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    WorkspacesAutoNameAlertQuery,
    WorkspacesAutoNameAlertQueryVariables
  >(WorkspacesAutoNameAlertDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useWorkspacesAutoNameAlertLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    WorkspacesAutoNameAlertQuery,
    WorkspacesAutoNameAlertQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorkspacesAutoNameAlertQuery,
    WorkspacesAutoNameAlertQueryVariables
  >(WorkspacesAutoNameAlertDocument, options);
}
export type WorkspacesAutoNameAlertQueryHookResult = ReturnType<
  typeof useWorkspacesAutoNameAlertQuery
>;
export type WorkspacesAutoNameAlertLazyQueryHookResult = ReturnType<
  typeof useWorkspacesAutoNameAlertLazyQuery
>;
export type WorkspacesAutoNameAlertQueryResult = Apollo.QueryResult<
  WorkspacesAutoNameAlertQuery,
  WorkspacesAutoNameAlertQueryVariables
>;
